module.exports = __webpack_public_path__ + "img/ch54.5de12a54.png";